/**
 * AIPE Shoes – Cart → Direct Checkout Redirect
 * After the customer clicks "Add to Cart", the browser redirects
 * straight to /checkout instead of opening the cart drawer.
 */
(function () {
  'use strict';

  var _originalFetch = window.fetch;

  window.fetch = function () {
    var args  = Array.prototype.slice.call(arguments);
    var url   = args[0];
    var promise = _originalFetch.apply(window, args);

    // Intercept every /cart/add request (AJAX add-to-cart)
    if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
      promise.then(function (response) {
        if (response.ok) {
          window.location.href = '/checkout';
        }
      });
    }

    return promise;
  };
})();
